import { AppData } from './index'

export const GaPageLoad = (state, data={}) => {
    if(AppData.gaobject && AppData.productdata) {
        const choices = Object.values(state)
        const requiredProducts = []
        for(let i = 0; i < choices.length; i++) {
            if(choices[i].required) {
                requiredProducts.push({
                    id: choices[i].product.productOsr,
                    name: choices[i].product.displayName,
                    category: choices[i].product.productType
                })
            }
        }
        if (window.jostensGaTracking) {
            if (!AppData.productdata.designId) {    // do not track GA events when editMode is set
                window.jostensGaTracking.init({
                    customerId: window.jostens.customer.number,
                    gaPageType: window.jostensGaTracking.gaPageTypeList.productDetailPage,
                    publishedCatalogId: AppData.productdata.publishedCatalogId,
                    publishedProductId: AppData.productdata.publishedProductId,
                    sourceCatalogType: AppData.productdata.sourceCatalogType
                })
            }
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerPageLoad,
                client: {
                    designerTotalSteps: parseInt(data.designerTotalSteps + 1),    // plus one: taking into account the Review step
                    selectedProducts: [ getMainProduct() ]
                },
                product: {
                    configuredPrice: parsePrice(AppData?.productdata?.configuredPrice)
                }
            })
            
        } else {
            AppData.gaobject.push({	
                event: "designerPageLoad", 
                pageType: "Product Detail Page:Jacket Designer",
                schoolType: window.jostens.customer.routerType,
                schoolId: window.jostens.customer.number, 
                schoolName: window.jostens.customer.extendedName,
                designerProductSku: AppData.productdata.productOsr,
                designerProductCategory: AppData.productdata.productType,
                designerType: "Jacket",
                designerOrderStepName: "Designer Viewed",
                ecommerce: {
                    detail: {
                        actionField: {
                            list: "Product Detail Page:Jacket Designer" 
                        },
                        products: requiredProducts
                    }
                }
            })
        }
    }
}

// GA Event not required
/* export const GaEnterSubstep = (state, productArray) => {
    if(AppData.gaobject) {
        const newProductArray = productArray.map((product, key) => {
            const newProduct = {
                id: product.productOsr,
                name: product.displayName,
                category: product.productType,
                list: "Cross Sell:Jacket Designer",
                position: key + 1
            }
            return newProduct
        })
        AppData.gaobject.push({	
            event: "productImpression",
            pageType: "Product Detail Page:Jacket Designer",
            designerStepNumber: state.stepnumber + 1,
            ecommerce: {
                impressions: {
                    products: newProductArray
                }
            }
        })
    }
} */

const parsePrice = price => parseFloat((price || 0).toFixed(2))

const getStepNumber = state => parseInt((state?.stepnumber || 0) + 1 + ((state?.step === 'Review') ? 1 : 0));

const getSubStepNumber = (state, data) => {
    let step = {}
    for(let i = 0; i < data.steps.length; i++) {
        if(data.steps[i].title === state.step) {
            step = data.steps[i]
        }
    }
    let substepNumber = 0
    for(let i = 0; i < step.substeps.length; i++) {
        if(step.substeps[i].title === state.substep) {
            substepNumber = i
        }
    }
    return substepNumber
}

const getMainProduct = () => {
    return AppData.productdata ? {
        osr: AppData.productdata.productOsr,
        name: AppData.productdata.displayName,
        productType: AppData.productdata.productType,
        price: parsePrice(AppData?.productdata?.configuredPrice),
        quantity: 1
    } : null
}

const getPriceAndQuantity = choice => {
    const basePrice = choice.basePrice ? choice.basePrice : 0
    const featurePrice = choice.featurePrice ? choice.featurePrice : 0
    let quantity = 1
    if(choice.product && choice.product.configurations && choice.product.configurations.length > 0) {
        for(let i = 0; i < choice.product.configurations.length; i++) {
            if(choice.product.configurations[i].featureOsr.includes("QTY")) {
                quantity = parseInt(choice.product.configurations[i].optionOsr)
            }
        }
    }
    const price = parsePrice((basePrice + featurePrice) / quantity)
    return { price, quantity }
}

const getSelectedProducts = state => {
    return (state?.choices) ? Object.values(state.choices).filter(f => (f.product?.productId) && (f.product.productId !== 'no')).map(choice => ({
        osr: choice.product.productOsr,
        name: choice.product.displayName,
        productType: choice.product.productType,
        ...getPriceAndQuantity(choice)
    })) : []
}

export const GaDesignerSubStepComplete = (state, data) => {
    if(AppData.gaobject && AppData.productdata) {
        let substepNumber = getSubStepNumber(state, data)
        if (window.jostensGaTracking) {
            let stepNumber = getStepNumber(state)
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerSubStepComplete,
                client: {
                    designerSubStepName: state.substep, 
                    designerSubStepNumber: parseInt(substepNumber + 1),
                    designerStepName: state.step, 
                    designerStepNumber: stepNumber, 
                    designerTotalSteps: parseInt(state.stepamount + 1),
                    selectedProducts: getSelectedProducts(state)
                },
                product: {
                    configuredPrice: parsePrice(state?.price)
                }
            })
        } else {
            AppData.gaobject.push({	
                event: "designerSubStepComplete",
                pageType: "Product Detail Page:Jacket Designer",
                schoolType: window.jostens.customer.routerType,
                schoolId: window.jostens.customer.number, 
                schoolName: window.jostens.customer.extendedName,
                designerProductSku: AppData.productdata.productOsr,
                designerProductCategory: AppData.productdata.productType,
                designerType: "Jacket",
                designerOrderStepName: "Designer Viewed",
                designerSubStepName: state.substep, 
                designerSubStepNumber: parseInt(substepNumber + 1), 
                designerStepName: state.step, 
                designerStepNumber: parseInt(state.stepnumber + 1), 
                designerTotalSteps: parseInt(state.stepamount)
            })
        }
    }
}

export const GaDesignerStepComplete = (state, data) => {
    if(AppData.gaobject && AppData.productdata) {
        let substepNumber = (state.step === 'Review') ? null : getSubStepNumber(state, data)
        if (window.jostensGaTracking) {
            let stepNumber = getStepNumber(state)
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerStepComplete,
                client: {
                    designerSubStepName: (typeof substepNumber === 'number') ? state.substep : '',
                    designerSubStepNumber: (typeof substepNumber === 'number') ? parseInt(substepNumber + 1) : '',
                    designerStepName: state.step, 
                    designerStepNumber: stepNumber, 
                    designerTotalSteps: parseInt(state.stepamount + 1),
                    selectedProducts: getSelectedProducts(state)
                },
                product: {
                    configuredPrice: parsePrice(state?.price)
                }
            })
        } else {
            AppData.gaobject.push({	
                event: "designerStepComplete",
                pageType: "Product Detail Page:Jacket Designer",
                schoolType: window.jostens.customer.routerType,
                schoolId: window.jostens.customer.number, 
                schoolName: window.jostens.customer.extendedName,
                designerProductSku: AppData.productdata.productOsr,
                designerProductCategory: AppData.productdata.productType,
                designerType: "Jacket",
                designerOrderStepName: "Designer Viewed",
                designerStepName: state.step, 
                designerStepNumber: state.stepnumber + 1, 
                designerTotalSteps: state.stepamount
            })
        }
    }
}

export const GaDesignerComplete = (state, data) => {
    if(AppData.gaobject && AppData.productdata) {
        let substepNumber = (state.step === 'Review') ? null : getSubStepNumber(state, data)
        if (window.jostensGaTracking) {
            let stepNumber = getStepNumber(state)
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerComplete,
                client: {
                    designerSubStepName: (typeof substepNumber === 'number') ? state.substep : '',
                    designerSubStepNumber: (typeof substepNumber === 'number') ? parseInt(substepNumber + 1) : '',
                    designerStepName: state.step, 
                    designerStepNumber: stepNumber, 
                    designerTotalSteps: parseInt(state.stepamount + 1),
                    selectedProducts: getSelectedProducts(state)
                },
                product: {
                    configuredPrice: parsePrice(state?.price)
                }
            })
        } else {
            AppData.gaobject.push({	
                event: "designerComplete",
                pageType: "Product Detail Page:Jacket Designer",
                schoolType: window.jostens.customer.routerType,
                schoolId: window.jostens.customer.number, 
                schoolName: window.jostens.customer.extendedName,
                designerProductSku: AppData.productdata.productOsr,
                designerProductCategory: AppData.productdata.productType,
                designerType: "Jacket",
                designerOrderStepName: "Designer Complete"
            })
        }
    }
}

export const GaAddToCart = (outputData, state) => {
    if(AppData.gaobject && AppData.productdata) {
        let productNames = ""
        for(let i = 0; i < outputData.length; i++) {
            if(i !== (outputData.length - 1 )) {
                productNames += `${outputData[i].displayName}|`
            } else {
                productNames += `${outputData[i].displayName}`
            }
        }
        const newOutputData = outputData.map((product) => {
            let quantity = 1
            let basePrice = product.basePrice ? product.basePrice : 0
            let featurePrice = product.featurePrice ? product.featurePrice : 0
            if(product.configurations && product.configurations.length > 0) {
                for(let i = 0; i < product.configurations.length; i++) {
                    if(product.configurations[i].featureOsr.includes("QTY")) {
                        quantity = parseInt(product.configurations[i].optionOsr)
                        
                    }
                }
            }
            return {
                id: product.productOsr,
                name: product.displayName,
                category: product.productType,
                price: (basePrice + featurePrice)/quantity,
                dimension49: window.jostens.customer.routerType,
                dimension50: window.jostens.customer.number, 
                dimension60: window.jostens.customer.extendedName,
                quantity: quantity
            }
        })
        if (window.jostensGaTracking) {
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.addToCart,
                client: {
                    designerTotalSteps: parseInt(state.stepamount + 1),

                    selectedProducts: newOutputData.map(product => ({
                        osr: product.id,
                        name: product.name,
                        productType: product.category,
                        price: parsePrice(product?.price),
                        quantity: parseFloat(product?.quantity || 0)
                    }))
                },
                product: {
                    configuredPrice: parsePrice(state?.price)
                }
            })
        } else {
            AppData.gaobject.push({
                "event": "addToCart",
                "pageType": "Product Detail Page:Jacket Designer",
                "schoolType": window.jostens.customer.routerType,
                "schoolId": window.jostens.customer.number,
                "schoolName": window.jostens.customer.extendedName,
                "designerProductSku": AppData.productdata.productOsr,
                "designerProductCategory": AppData.productdata.productType,
                "designerType": "Jacket",
                "designerOrderStepName": "Add to Cart",
                "ecommerce": {
                    "add": {
                        "products": newOutputData
                    }
                }
            })
        }
    }
}

export const GaSaveDesignInitiated = (state, data) => {
    if(AppData.gaobject && AppData.productdata) {
        let substepNumber = (state.step === 'Review') ? null : getSubStepNumber(state, data)
        if (window.jostensGaTracking) {
            let stepNumber = getStepNumber(state)
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.saveDesignInitiated,
                client: {
                    designerSubStepName: (typeof substepNumber === 'number') ? state.substep : '',
                    designerSubStepNumber: (typeof substepNumber === 'number') ? parseInt(substepNumber + 1) : '', 
                    designerStepName: state.step, 
                    designerStepNumber: stepNumber, 
                    designerTotalSteps: parseInt(state.stepamount + 1),
                    selectedProducts: getSelectedProducts(state)
                },
                product: {
                    configuredPrice: parsePrice(state?.price)
                }
            })
        }
    }
}

export const GaSavedDesignComplete = (state, data) => {
    if(AppData.gaobject && AppData.productdata) {
        let substepNumber = (state.step === 'Review') ? null : getSubStepNumber(state, data)
        if (window.jostensGaTracking) {
            let stepNumber = getStepNumber(state)
            window.jostensGaTracking.trackEvent({
                event: window.jostensGaTracking.gaEventNameList.productDetailPage.saveDesignComplete,
                client: {
                    designerSubStepName: (typeof substepNumber === 'number') ? state.substep : '',
                    designerSubStepNumber: (typeof substepNumber === 'number') ? parseInt(substepNumber + 1) : '', 
                    designerStepName: state.step, 
                    designerStepNumber: stepNumber, 
                    designerTotalSteps: parseInt(state.stepamount + 1),
                    selectedProducts: getSelectedProducts(state)
                },
                product: {
                    configuredPrice: parsePrice(state?.price)
                }
            })   
        } else {
            AppData.gaobject.push({	
                event: "savedDesignComplete",
                pageType: "Product Detail Page:Jacket Designer",
                schoolType: window.jostens.customer.routerType,
                schoolId: window.jostens.customer.number, 
                schoolName: window.jostens.customer.extendedName,
                designerProductSku: AppData.productdata.productOsr,
                designerProductCategory: AppData.productdata.productType,
                designerType: "Jacket",
                designerOrderStepName: "Designer Viewed",
                designerStepName: state.step, 
                designerStepNumber: state.step === "Review" ? "Review" : state.stepnumber + 1, 
                designerTotalSteps: state.stepamount
            })
        }
    }
}

